import React, { useRef } from 'react';
import { useState } from "react";

import emailjs from '@emailjs/browser';
import Section from '../../containers/Section';

const Form = () => {
  const formRef = useRef();
  const [input, setInput] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });

  const onChange = event => {
    setInput({
      ...input,
      [event.target.name]: event.target.value
    });
  }

  const onSubmit = event => {
    event.preventDefault();

    const { firstName, lastName, email, message } = input;
    const validateFilling = firstName && lastName && email && message.trim();
    const emailValidateFormat = email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (!validateFilling) return alert('Please fill the blank field.');
    if (!emailValidateFormat) return alert('Email format is invalid.');

    emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_CODE, process.env.REACT_APP_EMAILJS_TEMPALTE_ID, formRef.current, process.env.REACT_APP_EMAILJS_USER_ID)
      .then(() => {
        alert('Email sent.');
      })
      .catch(err => {
        console.log(err);
      });
  }

  return (
    <Section innerClass="pb-10 pt-24 max-w-[90%] lg:max-w-[70%] lg:pt-32 2xl:max-w-[50%]" outerClass="bg-slate-100/30">
      <div className="uppercase text-xl text-center tracking-widest text-slate-700 lg:text-2xl 2xl:text-3xl">Email Us Directly</div>
      <form className="pt-16 flex flex-col items-center" onSubmit={onSubmit} ref={formRef}>
        <label htmlFor="first-name" className="block w-full mb-2 p-2">
          <span className="block mb-1 text-slate-400 after:content-['*'] after:text-pink-500 after:ml-0.5 text-lg tracking-wider">First Name</span>
          <input
            id="first-name"
            name="firstName"
            type="text"
            className="w-full rounded-md px-4 py-3 border focus:outline-none focus:ring focus:ring-mai text-slate-700 text-base font-light"
            value={input.firstName}
            onChange={onChange}
          />
        </label>
        <label htmlFor="last-name" className="block w-full mb-2 p-2">
          <span className="block mb-1 text-slate-400 after:content-['*'] after:text-pink-500 after:ml-0.5 text-lg tracking-wider">Last Name</span>
          <input
            id="last-name"
            name="lastName"
            type="text"
            className="w-full rounded-md px-4 py-3 border focus:outline-none focus:ring focus:ring-main text-slate-700 text-base font-light"
            value={input.lastName}
            onChange={onChange}
          />
        </label>
        <label htmlFor="email" className="block w-full mb-2 p-2">
          <span className="block mb-1 text-slate-400 after:content-['*'] after:text-pink-500 after:ml-0.5 text-lg tracking-wider">Email</span>
          <input
            id="email"
            name="email"
            type="text"
            className="w-full rounded-md px-4 py-3 border focus:outline-none focus:ring focus:ring-main text-slate-700 text-base font-light"
            value={input.email}
            onChange={onChange}
          />
        </label>
        <label htmlFor="message" className="block w-full mb-2 p-2">
          <span className="block mb-1 text-slate-400 after:content-['*'] after:text-pink-500 after:ml-0.5 text-lg tracking-wider">Message</span>
          <textarea
            id="message"
            name="message"
            className="w-full rounded-md px-4 py-3 border focus:outline-none focus:ring focus:ring-main text-slate-700 text-base font-light"
            rows={4}
            value={input.message}
            onChange={onChange}
          />
        </label>
        <div className="w-full flex justify-center">
          <button type="submit" className="w-full uppercase font-semibold text-white bg-sky-900 m-2 p-2 rounded-md tracking-wider">Send Message</button>
        </div>
      </form>
    </Section>
  );
};

export default Form;
